import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
import "./MobileMenu.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import WhatsAppButton from "./WhatsAppButton";
import { Footer } from "./Footer";

const MobileMenu = ({ lightMode = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  // Temporarily force mobile menu to show on all screen sizes
  const [isMobile, setIsMobile] = useState(true);
  const [submenuOpen, setSubmenuOpen] = useState({}); // Track open/close state for each submenu

  useEffect(() => {
    // Listen for custom closeMenus event from FloatingKontaktButton
    const handleCloseMenus = () => {
      setIsOpen(false);
      setSubmenuOpen({});
    };

    window.addEventListener("closeMenus", handleCloseMenus);

    return () => {
      window.removeEventListener("closeMenus", handleCloseMenus);
    };
  }, []);

  // Removed scroll prevention - just open and close menu simply
  // useEffect(() => {
  //   if (isOpen) {
  //     document.body.classList.add("no-scroll");
  //   } else {
  //     document.body.classList.remove("no-scroll");
  //   }

  //   return () => {
  //     document.body.classList.remove("no-scroll");
  //   };
  // }, [isOpen]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    // Reset all categories to closed when opening the menu
    if (!isOpen) {
      setSubmenuOpen({});
    }
  };

  const toggleSubmenu = (name) => {
    setSubmenuOpen((prev) => ({
      [name]: !prev[name],
    }));
  };

  // Temporarily show mobile menu on all screen sizes for comparison
  // if (!isMobile) return null;
  return (
    <>
      <div className={`mobile-menu ${isOpen ? "open" : ""}`}>
        {/* Show hamburger icon on all screen sizes for comparison */}
        <div className="menu-icon" onClick={toggleMenu}>
          <div
            className={`luxury-hamburger ${isOpen ? "open" : ""}`}
            style={{ color: lightMode ? "var(--color-primary)" : "white" }}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div className="menu-links-container">
          <div className="menu-links full-height">
            <div className="menu-links-inner">
              <div className="menu-item">
                <span>
                  <Link to="/" onClick={toggleMenu}>
                    Die Werkstatt
                  </Link>
                </span>
              </div>
              {/* Example menu item with submenu */}

              {/* MOTORENBAU */}
              <div className="menu-item">
                <span
                  className={` ${
                    submenuOpen["motorenbau"] ? "submenu-open" : ""
                  }`}
                  onClick={() => toggleSubmenu("motorenbau")}
                >
                  Motorenbau
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    className={`submenu-arrow ${
                      submenuOpen["motorenbau"] ? "open" : ""
                    }`}
                  />
                </span>

                <div
                  className={`submenu ${
                    submenuOpen["motorenbau"] ? "open" : ""
                  }`}
                >
                  <Link
                    to="/motorenbau/leistungssteigerungen"
                    onClick={toggleMenu}
                  >
                    <span>Motorenbau & Leistungssteigerungen</span>
                  </Link>
                  <Link
                    to="/motorenbau/motor-revision-356-911-964-993"
                    onClick={toggleMenu}
                  >
                    <span class="menu-item-flex">
                      <div>Motor-Revision</div> <div> 911 / 964 / 993</div>
                    </span>
                  </Link>
                  <Link
                    to="/motorenbau/motor-instandsetzung-996-997-991-992"
                    onClick={toggleMenu}
                  >
                    <span class="menu-item-flex">
                      <div>Motor-Instandsetzung</div>{" "}
                      <div> 996 / 997 / 991</div>
                    </span>
                  </Link>
                  <Link
                    to="/motorenbau/getriebe-revision-911-964-993"
                    onClick={toggleMenu}
                  >
                    <span class="menu-item-flex">
                      <div>Getriebe-Revision</div> <div> 911 / 964 / 993</div>
                    </span>
                  </Link>
                </div>
              </div>

              {/* RESTAURATION & UMBAU */}
              <div className="menu-item">
                <span
                  className={` ${
                    submenuOpen["restauration"] ? "submenu-open" : ""
                  }`}
                  onClick={() => toggleSubmenu("restauration")}
                >
                  Restauration & Umbau
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    className={`submenu-arrow ${
                      submenuOpen["restauration"] ? "open" : ""
                    }`}
                  />
                </span>

                <div
                  className={`submenu ${
                    submenuOpen["restauration"] ? "open" : ""
                  }`}
                >
                  <Link to="/restauration" onClick={toggleMenu}>
                    <span>Porsche Restauration</span>
                  </Link>
                  <Link
                    to="/motorenbau/leistungssteigerungen"
                    onClick={toggleMenu}
                  >
                    <span>Porsche Leistungssteigerungen</span>
                  </Link>
                  {/* <Link to="/#engine-restoration" onClick={toggleMenu}>
                  <span>Porsche Fahrwerk</span>
                </Link>
                <Link to="/#engine-restoration" onClick={toggleMenu}>
                  <span>Porsche Bremsen</span>
                </Link>
                <Link to="/#engine-restoration" onClick={toggleMenu}>
                  <span>Porsche Auspuffanlagen</span>
                </Link>
                <Link to="/#engine-restoration" onClick={toggleMenu}>
                  <span>Porsche Karosserieumbau</span>
                </Link> */}
                  <Link to="/motorsport" onClick={toggleMenu}>
                    <span>Porsche Motorsport</span>
                  </Link>
                </div>
              </div>

              {/* SERVICE & WARTUNG  */}
              <div className="menu-item">
                <span
                  className={` ${submenuOpen["service"] ? "submenu-open" : ""}`}
                  onClick={() => toggleSubmenu("service")}
                >
                  Service, Wartung & Reparatur
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    className={`submenu-arrow ${
                      submenuOpen["service"] ? "open" : ""
                    }`}
                  />
                </span>

                <div
                  className={`submenu ${submenuOpen["service"] ? "open" : ""}`}
                >
                  <Link to="/service-wartung" onClick={toggleMenu}>
                    <span>Inspektion & Wartung</span>
                  </Link>
                  <Link to="/porsche-elektronik" onClick={toggleMenu}>
                    <span>Porsche Elektronik</span>
                  </Link>
                  <Link to="/porsche-reparatur" onClick={toggleMenu}>
                    <span>Porsche Reparatur</span>
                  </Link>
                  <Link to="/porsche-gutachten" onClick={toggleMenu}>
                    <span>TÜV-Eintragung & Gutachten</span>
                  </Link>
                  {/* <Link to="/#engine-restoration" onClick={toggleMenu}>
                  <span>Unfallinstandsetzung</span>
                </Link> */}
                </div>
              </div>

              {/* ANKAUF & VERKAUF */}
              <div className="menu-item">
                <span
                  className={` ${submenuOpen["sales"] ? "submenu-open" : ""}`}
                  onClick={() => toggleSubmenu("sales")}
                >
                  Ankauf & Verkauf
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    className={`submenu-arrow ${
                      submenuOpen["sales"] ? "open" : ""
                    }`}
                  />
                </span>

                <div
                  className={`submenu ${submenuOpen["sales"] ? "open" : ""}`}
                >
                  <Link to="/aktuelle-angebote" onClick={toggleMenu}>
                    <span>Aktuelle Angebote</span>
                  </Link>
                  <Link to="/porsche-verkaufen" onClick={toggleMenu}>
                    <span>Porsche verkaufen</span>
                  </Link>
                </div>
              </div>

              <div className="menu-item">
                <span>
                  <Link to="/kontakt" onClick={toggleMenu}>
                    Kontakt
                  </Link>
                </span>
              </div>
            </div>
            {/* <Footer /> */}
          </div>
        </div>
      </div>
      <div className={`${isOpen ? "milk-glass blur" : ""}`}></div>
    </>
  );
};

export default MobileMenu;
